import Tooltip from '@SonarCX/components/atoms/Tooltip'
import { useEnvironment } from '@SonarCX/providers/EnvironmentProvider'
import useStyles from './styles'

interface MessageReaction {
  reaction: string
  count: number
  users: APIUser[]
}

interface ReactionProps {
  reaction: MessageReaction
  handleEmojiRemove: () => void
}

const Reaction: React.FC<ReactionProps> = ({ reaction, handleEmojiRemove }) => {
  const { user: currentUser } = useEnvironment()
  const isYours = reaction.users.some(user => user.id === currentUser?.id)
  const classes = useStyles({ isYours })
  const handleOnReactionClick = () => {
    if (!isYours) return
    handleEmojiRemove()
  }

  return (
    <Tooltip
      arrow
      title={
        <div className={classes.tooltipRoot}>
          {reaction.reaction}
          {reaction.users.map(user => (
            <div key={`reaction-tooltip-${user.id}`}>
              {user.name} {currentUser?.id === user.id ? ' (You)' : ''}
            </div>
          ))}
        </div>
      }
    >
      <span className={classes.root} onClick={handleOnReactionClick}>
        {reaction.reaction}
        {reaction.count > 1 && (
          <span className={classes.count}>{reaction.count}</span>
        )}
      </span>
    </Tooltip>
  )
}

export default Reaction
